"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _reactRedux = require("react-redux");

var _notistack = require("notistack");

var _actions = require("../../../redux/organizations/actions");

var _selectors = require("../../../redux/organizations/selectors");

var _selectors2 = require("../../../redux/login/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OrgSelect = function OrgSelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      fullWidth = _ref.fullWidth,
      disabled = _ref.disabled;

  var _useOrgsSelector = (0, _selectors.useOrgsSelector)(),
      orgs = _useOrgsSelector.orgs,
      orgsLoading = _useOrgsSelector.orgsLoading;

  var _useLoginSelector = (0, _selectors2.useLoginSelector)(),
      orgIds = _useLoginSelector.orgIds;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  (0, _react.useEffect)(function () {
    if (!orgs || !orgs.length) {
      console.log("loadOrganizations", orgIds);
      dispatch((0, _actions.loadOrganizations)(orgIds, enqueueSnackbar));
    }
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  return orgsLoading || !orgs ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 30
  }) : /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    fullWidth: fullWidth,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    id: "organizationLabel"
  }, "Organization"), /*#__PURE__*/_react.default.createElement(_Select.default, {
    name: "organization",
    value: value,
    onChange: onChange,
    labelId: "organizationLabel",
    fullWidth: fullWidth
  }, orgs.map(function (org) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: org.id,
      key: org.id
    }, org.name);
  })));
};

OrgSelect.propTypes = {
  value: _propTypes.default.string.isRequired
};
OrgSelect.defaultProps = {
  fullWidth: false,
  disabled: false
};
var _default = OrgSelect;
exports.default = _default;